import { FullscreenExitOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const PlaceholderOverlay = styled(Flex)`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.colorBgContainer};
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: ${({ theme }) => theme.borderRadius}px;
`;

export interface IMapExtendedViewPlaceholderProps {
  /** Chiude la vista estesa riportando la mappa qui. */
  onReduce: () => void;
}

/**
 * Riempie lo spazio inline lasciato vuoto quando la mappa è spostata nella
 * Modal estesa, offrendo un rientro rapido alla vista standard.
 */
export function MapExtendedViewPlaceholder(
  props: IMapExtendedViewPlaceholderProps,
) {
  const { onReduce } = props;
  const { t } = useTranslation();

  return (
    <PlaceholderOverlay vertical align="center" justify="center" gap="0.75rem">
      <Typography.Text type="secondary">
        {t(
          'map-widget.extended-view.placeholder',
          'Mappa aperta in visualizzazione estesa',
        )}
      </Typography.Text>
      <Button icon={<FullscreenExitOutlined />} onClick={onReduce}>
        {t('map-widget.extended-view.close', 'Riduci mappa')}
      </Button>
    </PlaceholderOverlay>
  );
}
